import { Box, Typography } from "@mui/material";
import { useTheme } from "@mui/material/styles";
// import useMediaQuery from "@mui/material/useMediaQuery";
import React, { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useOutletContext } from "react-router-dom";
import { HiddenCTAStyle } from "./CarouselCard.style";
// import { LEVEL, STATUS_LO } from "../../consts";
import { ButtonDigited } from "../../components/Button/Button.variants";
import { ENROLL_TYPE, LEVEL } from "../../consts";
import { useButtonStatusMap, usePlayResumeVideo } from "../../hooks";
import {
  useInvalidateLearningObjectQuery
} from "../../queries";
import { OutletContext } from "../../routes";
import { useNavigate } from "../../services";
import { useLanguageStore } from "../../stores";
import { CardCta, StyledBoxContact } from "../CardCta";
import type { CardCtaProps } from "../CardCta/CardCta.types";
import { Icon } from "../Icon";

export const HiddenCTA = ({
  courseId = null,
  disabled = false,
  ecmRegistration,
  enrollType,
  id,
  isBookmarkPage = false,
  isCard = false,
  isEditorial = false,
  ecm_specialization,
  isExpired,
  isStandAlone,
  labelMoreInfo = false,
  learningObjectType,
  learningObjectTypology,
  linkVirtualClass,
  percentageOfCompletion,
  parentId, // for favourites
  grandParentId, // for favourites
  rootId = null,
  setOpenRegistrationModal,
  // setOpenModalEcm,
  setOpenTojModal,
  status,
  simple = false,
  triggerOpenTabs,
  // vertical = false,
  canAccessNow,
  credits,
  isLinkRelative,
  externalFileUrl,
  link,
  cardType,
  attributes,
  isHovered,
  isFavourite,
  showDetailsButton,
  isHeroBanner,
  ctaPosition
}: CardCtaProps) => {

  const { sectionUrl } = useOutletContext<OutletContext>();
  const language = useLanguageStore(state => state.language)?.id;
  const { t } = useTranslation();
  const navigate = useNavigate();
  const theme = useTheme();

  const {
    resumeLink,
    bannerVisible,
    enrollmentMutationHadSuccess,
    enrollmentIsLoading,
    resumeLinkOpenEsternal,
    setBannerVisible,
    resumeContent,
    addEnrollmentMutation
  } = usePlayResumeVideo({
    ecm_specialization,
    ecmRegistration,
    enrollType,
    isCard,
    learningObjectType,
    learningObjectTypology,
    id,
    labelMoreInfo,
    sectionUrl,
    status,
    setOpenTojModal,
    setOpenRegistrationModal,
    triggerOpenTabs,
    linkVirtualClass,
    navigate,
    parentId,
    rootId,
    grandParentId,
    courseId,
    isExpired,
    attributesIds:attributes
  });

  const { invalidateLearningObject } = useInvalidateLearningObjectQuery({
    courseId: courseId,
    id: id,
    learningObjectTypology: learningObjectTypology,
    rootId: rootId
  });

  useEffect(() => {
    if (enrollmentMutationHadSuccess && !enrollmentIsLoading) {
      if (enrollType === "AUTO_ENROLL") {
        if (resumeLinkOpenEsternal) {
          window.open(resumeLinkOpenEsternal, "_blank", "noreferrer");
        } else {
          resumeContent();
        }
      } else {
        invalidateLearningObject();
      }

    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    enrollType,
    enrollmentIsLoading,
    enrollmentMutationHadSuccess,
    navigate,
    resumeLink,
    courseId,
    rootId,
    resumeLinkOpenEsternal
  ]);

  const buttonText = useButtonStatusMap({
    ecm_specialization:ecm_specialization,
    ecmRegistration:ecmRegistration,
    enrollType:enrollType,
    isCard: true,
    isSurvey:false,
    isTest:false,
    learningObjectType:learningObjectType,
    learningObjectTypology:learningObjectTypology,
    madeAttempts:0,
    percentageOfCompletion:percentageOfCompletion
  });

  const resumeLinkLinkedin = learningObjectTypology === LEVEL.DA_LTI || learningObjectTypology === LEVEL.DA_LINKEDIN ?
    `/esplora/scorm/${id}/${learningObjectTypology}?lang=${language}` :
    undefined;



  return (

    <HiddenCTAStyle className="collapse_cta" >
      <StyledBoxContact
        tabIndex={ -1 }
        $visible={ bannerVisible }
        width="100%"
        sx={ {
          left: 0,
          right: "unset",
          top: "-40px"
        } }
      >
        <Typography
          color={ theme.customColors.textPrimaryAlternative }
          fontSize={ theme.spacing(1.625) }
          fontWeight={ 500 }
        >
          { bannerVisible ? t("contact_text") : "" }
        </Typography>
        <Icon
          aria-hidden="true"
          icon="close"
          size={ 24 }
          color={ theme.palette.primary?.main }
          onClick={ () => {
            setBannerVisible(false);
          } }
        />
      </StyledBoxContact>
      <Box sx={ { display:"flex" } }>
        { (sectionUrl === "per-te") ?
          <ButtonDigited
            sx={ { mr: 1 } }
            typology={ "primary" }
            buttonSize="md"
            disabled={ disabled }
            aria-label={ t(buttonText[status]?.label) }
            onClick={ (e)=> {
              e.preventDefault();
              if(
                (enrollType === ENROLL_TYPE.AUTO_ENROLL ||
                            enrollType === ENROLL_TYPE.REQUESTED_AUTO_ENROLL)
                            && (
                              !status ||
                              status === "N"
                            )
                            && !isExpired
              ) {
                addEnrollmentMutation();
              } else if(resumeLinkLinkedin && resumeLink.includes("guarda")){
                window.open(resumeLinkLinkedin, "_blank", "noreferrer");
              } else {
                navigate(resumeLink);
              }
            } }
            text={ t(buttonText[status]?.label) }
          /> : null
        }
        <CardCta
          courseId={ courseId }
          rootId={ rootId }
          isExplorePage={ true }
          canAccessNow={ canAccessNow }
          enrollType={ enrollType }
          isStandAlone={ isStandAlone }
          className={ "card-cta" }
          ctaPosition={ ctaPosition }
          id={ id }
          ecm_specialization={ false }
          ecmRegistration={ false }
          learningObjectTypology={ learningObjectTypology }
          isBookmarkPage={ isBookmarkPage }
          status={ status }
          learningObjectType={ learningObjectType }
          percentageOfCompletion={ percentageOfCompletion }
          simple={ simple }
          isCard={ isCard }
          isEditorial={ isEditorial }
          grandParentId={ grandParentId }
          parentId={ parentId }
          credits={ credits }
          showDetailsButton={ showDetailsButton }
          customBorder="2px solid !important"
          isLinkRelative={ isLinkRelative }
          externalFileUrl={ externalFileUrl }
          link={ link }
          cardType={ cardType }
          disabled={ disabled }
          isHovered={ isHovered }
          isFavourite={ isFavourite }
          isHeroBanner={ isHeroBanner }
          sx={ {
            ".MuiButton-root": {
              minWidth: "0",
              height: "2.5rem"
            },
            ">div": {
              [theme.breakpoints.down("sm")]: {
                gap: theme.spacing(2)
              }
            }
          } }
        />
      </Box>
    </HiddenCTAStyle>
  );
};
